import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingBottom: 24,
    borderBottom: `1px solid ${Colors.Grey3}`,
  },
}));

export default useStyles;
